import React from "react";
import { Link } from "react-router-dom";
import { AlignJustify, Gamepad2 } from "lucide-react";

const Hero = () => {
  return (
    <section className="hero">
      <div className="container hero-grid">
        <div>
          <span className="eyebrow"><span className="dot"></span>24/7 Dispatch Service</span>
          <h1>Your success<br />is our <span>mission</span>.</h1>
          <p className="lede">
            Flying Fleet Dispatch LLC keeps your trucks loaded and moving. From carrier
            sourcing to freight forwarding, exclusive broker loads to round-the-clock
            dispatching &mdash; we handle the loads, you focus on driving.
          </p>
          <div className="hero-actions">
            <a href="#loadboard" className="btn btn-primary">
              <AlignJustify size={16} />
              View Available Loads
            </a>
            <Link to="/games" className="btn btn-outline" data-testid="hero-games-btn">
              <Gamepad2 size={16} />
              Play the Games Free
            </Link>
            <a href="#contact" className="btn btn-outline">Get Dispatched</a>
          </div>
          <div className="hero-stats">
            <div><div className="num">24/7</div><div className="lab">Dispatch Coverage</div></div>
            <div><div className="num">100%</div><div className="lab">Carrier Vetted</div></div>
            <div><div className="num">1:1</div><div className="lab">Dedicated Dispatcher</div></div>
          </div>
        </div>

        <div className="route-card">
          <div className="route-label"><span>Origin</span><span>Destination</span></div>
          <div className="route-cities"><span>Joliet, IL</span><span>Dallas, TX</span></div>
          <svg viewBox="0 0 400 120" aria-hidden="true">
            <path d="M10,60 C 90,10 210,110 290,55 C 350,15 380,60 390,40" fill="none" stroke="#2f77c9" strokeWidth="3" strokeDasharray="2 10" strokeLinecap="round" />
            <circle cx="10" cy="60" r="7" fill="#63c26a" />
            <circle cx="390" cy="40" r="7" fill="#ffffff" />
            <g className="truck-marker">
              <rect x="-11" y="-7" width="22" height="14" rx="3" fill="#63c26a" />
            </g>
          </svg>
          <div className="route-meta">
            <div><div className="v">925 mi</div><div className="l">Distance</div></div>
            <div><div className="v">Dry Van</div><div className="l">Equipment</div></div>
            <div><div className="v">$2,450</div><div className="l">Rate</div></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
